'use strict';
const px = require('@mindmup/mapjs-core/src/util/px');

module.exports = function updateNodeText(nodeView, textDOM) {
	if (!nodeView || !textDOM) {
		throw new Error('invalid-args');
	}
	const nodeMetrics = nodeView.metrics,
		nodeTheme = nodeView.theme;
	if (!nodeMetrics.text) {
		textDOM.style.display = 'none';
		textDOM.style.maxWidth = px(Math.max(nodeTheme.text.maxWidth, nodeMetrics.bubble.width - nodeTheme.margin));
		textDOM.style.margin = px(nodeTheme.margin);
	} else {
		textDOM.style.width = px(nodeMetrics.text.width);
		textDOM.style.marginTop = px(nodeMetrics.text.y - nodeMetrics.bubble.border - nodeMetrics.bubble.y);
		textDOM.style.marginLeft = px(nodeMetrics.text.x - nodeMetrics.bubble.border - nodeMetrics.bubble.x);
		textDOM.style.marginBottom = px(
			nodeMetrics.bubble.y + nodeMetrics.bubble.height
			- nodeMetrics.text.y - nodeMetrics.text.height
			- nodeMetrics.bubble.border);
		textDOM.style.marginRight = px(
			nodeMetrics.bubble.x + nodeMetrics.bubble.width
			- nodeMetrics.text.x - nodeMetrics.text.width
			- nodeMetrics.bubble.border);
		textDOM.style.maxWidth = px(Math.max(nodeTheme.text.maxWidth, nodeMetrics.text.width));
		textDOM.innerText = nodeView.title || ' ';
	}
};
